/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import { GET_SEARCH_RESULTS, GET_SEARCH_RESULTS_SUCCESS, GET_SEARCH_RESULTS_FAIL } from './redux';
import Request from 'client/utils/xhrWrapper';

export function* getSearchResults() {
  yield takeEvery(GET_SEARCH_RESULTS, function* ({ data }) : any {
    try {
      const response = yield Request.get(`video/video/search/text/${data}`);
      const responseData = _.get(response, ['data', '0', 'video', 'data']);
      yield put({
        type: GET_SEARCH_RESULTS_SUCCESS,
        data: {
          list: (responseData && responseData.length > 0) ? _.get(response, ['data']) : { notFound: true },
          query: data,
        },
      });
    } catch (error) {
      yield put({ type: GET_SEARCH_RESULTS_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getSearchResults),
  ]);
}
